import { surveyService } from '../index.js'

/**
 * 微信相关接口 - 使用问卷服务
 */

// 获取微信JSSDK配置
export const wechatApi = {
  // 获取微信JSSDK配置
  getWechatConfig: (url) => {
    return surveyService({
      url: '/admin-api/medium/wechat/js-config',
      method: 'get',
      params: { url }
    })
  },

  // 获取微信音频流（返回二进制 Blob）
  getWechatAudioUrl: (mediaId) => {
    return surveyService({
      url: '/admin-api/medium/wechat/audio-stream',
      method: 'get',
      params: { mediaId },
      responseType: 'blob' // 指定响应类型为二进制流
    })
  },

  /**
   * 上传微信录音获取文件名
   * @param {Object} params
   * @param {string} params.mediaId - 微信录音mediaId
   * @param {string} [params.accessToken] - 访问令牌（可选，后期登录后使用）
   * @returns {Promise} 后端返回包含文件名的 JSON
   */
  uploadAudio: (params) => {
    return surveyService({
      url: '/admin-api/medium/wechat/upload-audio',
      method: 'get',
      params: {
        mediaId: params.mediaId,
        accessToken: params.accessToken
      }
    })
  }
}